// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6515":"c4aface0","7454":"7acd2fda","8500":"c7c896e8","9198":"e26213cb"}[chunkId] + ".chunk.css";
};